import React, { useState, useEffect } from 'react';
import { Table, Badge } from 'react-bootstrap';
import { ButtonComponent } from './elements';
import Swal from 'sweetalert2';
import { obtenerMisSolicitudesCupo } from '../api/giras.ts';

export default function MisSolicitudesCupoComponent({ giraId, onRefresh }) {
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarSolicitudes();
  }, [giraId, onRefresh]);

  const cargarSolicitudes = async () => {
    setLoading(true);
    const resultado = await obtenerMisSolicitudesCupo(giraId);
    if (!resultado.error && resultado.data) {
      setSolicitudes(resultado.data);
    }
    setLoading(false);
  };

  const getEstadoBadge = (estado) => {
    switch (estado) {
      case 'pendiente':
        return <Badge bg="warning" text="dark">Pendiente de Revisión</Badge>;
      case 'aprobado':
        return <Badge bg="success">Aprobado</Badge>;
      case 'rechazado':
        return <Badge bg="danger">Rechazado</Badge>;
      default:
        return <Badge bg="secondary">{estado}</Badge>;
    }
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return '-';
    return new Date(fecha).toLocaleDateString('es-CL');
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <p>Cargando solicitudes...</p>
      </div>
    );
  }

  if (solicitudes.length === 0) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '30px',
        backgroundColor: '#f5f5f5',
        borderRadius: '4px'
      }}>
        <i className='material-icons' style={{ fontSize: '3rem', color: '#ccc' }}>note</i>
        <p style={{ color: '#999', marginTop: '10px' }}>
          No tienes solicitudes de cupo registradas
        </p>
      </div>
    );
  }

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{ overflowX: 'auto' }}>
        <Table striped bordered hover size="sm">
          <thead style={{ backgroundColor: '#2196F3', color: 'white' }}>
            <tr>
              <th style={{ textAlign: 'center' }}>Alumno</th>
              <th style={{ textAlign: 'center' }}>RUT Alumno</th>
              <th style={{ textAlign: 'center' }}>Estado</th>
              <th style={{ textAlign: 'center' }}>Fecha Solicitud</th>
              <th style={{ textAlign: 'center' }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {solicitudes.map((solicitud, index) => (
              <tr key={index}>
                <td>
                  <strong>{solicitud.soc_alumno_nombres} {solicitud.soc_alumno_apellidos}</strong>
                </td>
                <td>{solicitud.soc_alumno_rut}-{solicitud.soc_alumno_dv}</td>
                <td style={{ textAlign: 'center' }}>
                  {getEstadoBadge(solicitud.soc_estado)}
                </td>
                <td style={{ textAlign: 'center' }}>
                  {formatearFecha(solicitud.soc_fecha_creacion)}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <ButtonComponent
                    className="btn btn-sm btn-info"
                    onClick={() => mostrarDetalle(solicitud)}
                    style={{ marginRight: '5px' }}
                  >
                    <i className='material-icons' style={{ fontSize: '0.9rem' }}>search</i> Ver
                  </ButtonComponent>
                  {solicitud.soc_estado === 'rechazado' && (
                    <span style={{ marginLeft: '5px', fontSize: '0.8rem', color: '#d32f2f' }}>
                      ⓘ Ver motivo
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );

  function mostrarDetalle(solicitud) {
    let contenidoHTML = `
      <div style="text-align: left;">
        <h5 style="color: #2196F3; margin-bottom: 15px;">
          <strong>Datos del Alumno</strong>
        </h5>
        <p><strong>Nombre:</strong> ${solicitud.soc_alumno_nombres} ${solicitud.soc_alumno_apellidos}</p>
        <p><strong>RUT:</strong> ${solicitud.soc_alumno_rut}-${solicitud.soc_alumno_dv}</p>
        <p><strong>Nacionalidad:</strong> ${solicitud.soc_alumno_nacionalidad || '-'}</p>
        <p><strong>Fecha de Nacimiento:</strong> ${formatearFecha(solicitud.soc_alumno_fecha_nacimiento)}</p>
        <p><strong>Género:</strong> ${solicitud.soc_alumno_genero === 'M' ? 'Masculino' : solicitud.soc_alumno_genero === 'F' ? 'Femenino' : '-'}</p>
        <p><strong>Calidad:</strong> ${solicitud.soc_alumno_calidad}</p>
        ${solicitud.soc_alumno_enfermedad ? `<p><strong>Enfermedad/Condición:</strong> ${solicitud.soc_alumno_enfermedad}</p>` : ''}
        ${solicitud.soc_alumno_tipo_sangre ? `<p><strong>Tipo de Sangre:</strong> ${solicitud.soc_alumno_tipo_sangre}</p>` : ''}
        
        <hr style="margin: 20px 0;" />
        
        <h5 style="color: #2196F3; margin-bottom: 15px;">
          <strong>Datos del Responsable</strong>
        </h5>
        <p><strong>Nombre:</strong> ${solicitud.soc_responsable_nombres} ${solicitud.soc_responsable_apellidos}</p>
        <p><strong>RUT:</strong> ${solicitud.soc_responsable_rut}-${solicitud.soc_responsable_dv}</p>
        <p><strong>Parentesco:</strong> ${solicitud.soc_responsable_parentesco || '-'}</p>
        
        <hr style="margin: 20px 0;" />
        
        <h5 style="color: #2196F3; margin-bottom: 15px;">
          <strong>Estado de la Solicitud</strong>
        </h5>
        <p><strong>Estado:</strong> 
          <span style="margin-left: 10px; padding: 5px 10px; border-radius: 3px; 
            background-color: ${solicitud.soc_estado === 'pendiente' ? '#fff3cd' : solicitud.soc_estado === 'aprobado' ? '#d4edda' : '#f8d7da'};
            color: ${solicitud.soc_estado === 'pendiente' ? '#856404' : solicitud.soc_estado === 'aprobado' ? '#155724' : '#721c24'};
          ">
            ${solicitud.soc_estado.charAt(0).toUpperCase() + solicitud.soc_estado.slice(1)}
          </span>
        </p>
        <p><strong>Fecha de Solicitud:</strong> ${formatearFecha(solicitud.soc_fecha_creacion)}</p>
        ${solicitud.soc_fecha_aprobacion ? `<p><strong>Fecha de Revisión:</strong> ${formatearFecha(solicitud.soc_fecha_aprobacion)}</p>` : ''}
        ${solicitud.soc_razon_rechazo ? `<p><strong>Motivo del Rechazo:</strong> ${solicitud.soc_razon_rechazo}</p>` : ''}
      </div>
    `;

    Swal.fire({
      title: 'Detalle de Solicitud',
      html: contenidoHTML,
      icon: 'info',
      confirmButtonText: 'Cerrar',
      width: '600px'
    });
  }
}
